import { TFn } from "@/app/translations/TFn";
import { objectiveSuggestions } from "../SequenceObjectiveForm/SequenceObjectiveForm.logic";

const EMPTY_SUGGESTIONS_SHOWN = 4;

export function emptyObjectiveExamples(T: TFn): string[] {
  return objectiveSuggestions(T, []).slice(0, EMPTY_SUGGESTIONS_SHOWN);
}
